import { Card } from "../../../components/cards";
import { useMe } from "../../users/hooks/useMe";
import { Activity } from "lucide-react";
import { RecentCustomersWidget } from "../components";
import { MyTasksWidget } from "../../customer-tasks/components";

export const Customer = () => {
  const { data } = useMe();

  return (
    <div className="space-y-4 p-2">
      {/* Welcome Banner */}
      <Card
        padding="md"
        className="bg-gradient-to-r from-primary-600 to-primary-700 border-0 text-white"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
            <Activity className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold mb-1 text-white">
              Bienvenue, {data?.me?.firstname ?? ""}
            </h2>
            <p className="text-sm text-white/90">
              Suivez vos clients, prospections et rapports SEO
            </p>
          </div>
        </div>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RecentCustomersWidget />
        <MyTasksWidget />
      </div>
    </div>
  );
};
